const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]

// Create date object and return month and date
export const ReturnDate = date => {
  var parts = date.match(/(\d+)/g)
  const newDate = new Date(parts[0], parts[1] - 1, parts[2])
  const month = newDate.getMonth()
  const day = newDate.getDate()

  return monthNames[month] + " " + day
}

const addZero = i => {
  if (i < 10) {
    i = "0" + i
  }
  return i
}

export const ReturnDateAndTime = date => {
  var parts = date.match(/(\d+)/g)
  const newDate = new Date(parts[0], parts[1], parts[2])
  const month = newDate.getMonth()
  const day = newDate.getDate()

  const timeDate = new Date(date)
  let hours = addZero(timeDate.getHours())
  const minutes = addZero(timeDate.getMinutes())
  const suffix = hours >= 12 ? "PM" : "AM"

  hours = ((hours + 11) % 12) + 1

  return month + "/" + day + " " + hours + ":" + minutes + suffix + " EST"
}

export const convertContentStackAsset = url => {
  const endpoint = "https://www.draftkings.com/landingpages-assets/"

  const startIdx = url.indexOf("assets/") + 7
  return endpoint + url.substr(startIdx)
}

export const KEY_CODES = Object.freeze({
  RETURN: 'Enter',
  ESC: 'Escape',
  SPACE: 'Space',
  END: 'End',
  HOME: 'Home',
  UP: 'ArrowUp',
  DOWN: 'ArrowDown',
});
